import './MissionCard.css'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'

const reveal = {
  hidden: { opacity: 0, y: 30 },
  visible: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay },
  }),
}

export default function MissionCard() {
  return (
    <section className="services">
      <motion.div
        className="service"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.25 }}
        custom={0}
        variants={reveal}
      >
        <motion.div className="project-card-left" variants={reveal} custom={0.05}>
          <div className="project-left">
            <h3>Gestionnaires de Paie dédiés</h3>
            <p>
              Vous bénéficiez d'interlocuteurs uniques qui connaissent vos
              dossiers et vos méthodes de travail.
            </p>
            <Link to="/Contact" className="btn">Contactez Nous!</Link>
          </div>
          <motion.div className="project-right" variants={reveal} custom={0.1}>
            <img src={`${process.env.PUBLIC_URL}/images/accounting.jpg`} alt="Gestion paie et comptable dédiée" loading="lazy" decoding="async" />
          </motion.div>
        </motion.div>
      </motion.div>

      <motion.div
        className="service reverse"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.25 }}
        custom={0.1}
        variants={reveal}
      >
        <motion.div className="project-card-right" variants={reveal} custom={0.15}>
          <motion.div className="project-right" variants={reveal} custom={0.2}>
            <img src={`${process.env.PUBLIC_URL}/images/tax.jpg`} alt="Conseil tarifaire et optimisation de marge sociale" loading="lazy" decoding="async" />
          </motion.div>
          <div className="project-left">
            <h3>Accompagnement dans votre politique tarifaire</h3>
            <p>
              Nous vous aidons à structurer vos marges
              et à valoriser votre offre sociale auprès de vos clients finaux.
            </p>
            <Link to="/Contact" className="btn">Contactez Nous!</Link>
          </div>
        </motion.div>
      </motion.div>

      <motion.div
        className="service"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.25 }}
        custom={0.2}
        variants={reveal}
      >
        <motion.div className="project-card-left" variants={reveal} custom={0.25}>
          <div className="project-left">
            <h3>Assistance en cas de contrôle URSSAF</h3>
            <p>
              Nous sécurisons vos procédures et vous
              accompagnons techniquement lors des contrôles pour protéger vos clients et votre
              responsabilité.
            </p>
            <Link to="/Contact" className="btn">Contactez Nous!</Link>
          </div>
          <motion.div className="project-right" variants={reveal} custom={0.3}>
            <img src={`${process.env.PUBLIC_URL}/images/conseil.jpg`} alt="Assistance contrôle URSSAF et conformité sociale" loading="lazy" decoding="async" />
          </motion.div>
        </motion.div>
      </motion.div>
    </section>
  )
}